/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const resourceCreateRequestSchema = z.object({
  email: z.email().min(0).max(255).nullish(),
  employmentType: z.enum(['EMPLOYEE', 'CONTRACTOR', 'PARTNER', 'ON_DEMAND', 'AI_AGENT']),
  name: z.string().min(1),
  sourceId: z.string().nullish(),
  type: z.enum(['RESOURCE', 'PLACEHOLDER']),
});
